module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo_title"
  }, [_vm._v("习习教师")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "personal"
  }, [(_vm.userInformation.avatar) ? _c('img', {
    staticClass: "profile",
    attrs: {
      "src": _vm.userInformation.avatar,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('em'), _vm._v(" "), _c('div', {
    staticClass: "exit"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.goPersonal
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/personal-icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("个人中心")])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/warn.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("退出登录")])])])])])]), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meun"
  }, [_c('ul')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27158d21","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner/topBanner.vue
// module id = 1167
// module chunks = 1